import React from 'react';
import PropTypes from 'prop-types';
import IconWrapper from '@ant-design/icons';
import feather from 'feather-icons';

const createIconComponent = (name, attrs = {}) => {
  const icon = feather.icons[name] || customIcons[name];
  const { size, color, fill, strokeWidth = '2', className = '' } = attrs;
  let width = 24, height = 24;

  if (size) {
    if (Array.isArray(size)) {
      width = size[0];
      height = size[1];
    } else {
      width = height = size;
    }
    // if (typeof size === 'number') {
    //   width = height = size;
    // } else {
    //   width = size[0];
    //   height = size[1];
    // }
  }

  if (!icon) {
    throw new Error(`Unknown icon ${name}`);
  }

  return () => (
    <svg
      width={width}
      height={height}
      viewBox={icon.viewBox || "0 0 24 24"}
      fill={fill || 'none'}
      stroke={color || "currentColor"}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`feather feather-${name} ${className}`}
    >
      <g dangerouslySetInnerHTML={{ __html: icon.contents }} />
    </svg>
  );
};

const Icon = ({ name, rotate, ...props }) => (
  <IconWrapper orientation="center" {...props} component={createIconComponent(name, props)} />
);

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.arrayOf(PropTypes.string),
  ]),
  className: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const customIcons = {
  inbound: {
    contents: `
      <g opacity="0.5">
        <path d="M9 21L5 21C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19L3 5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3L9 3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16 17L21 12L16 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21 12L9 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    `
  },
  outbound: {
    contents: `
      <g opacity="0.5">
        <path d="M15 3L19 3C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5L21 19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21L15 21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 17L15 12L10 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15 12L3 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </g>    
    `,
  },
  sendAndShare: {
    viewBox: '0 0 20 20',
    contents: `
      <defs>
        <clipPath id="clip0_7410_2008">
          <rect width="100%" height="100%" />
        </clipPath>
      </defs>
      <g clip-path="url(#clip0_7410_2008)">
        <path d="M4.43585 16.565L16.46 10.9825C17.2917 10.5967 17.2917 9.40167 16.46 9.01584L4.43585 3.43501C3.57335 3.03501 2.66085 3.88334 2.98335 4.78584L4.84419 9.99751L2.98335 15.215C2.66085 16.1167 3.57335 16.965 4.43585 16.565Z" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.84167 10H17.0833" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    `
  },
  lightSparkle: {
    viewBox: '0 0 20 20',
    contents: `
      <defs>
        <clipPath id="clip0_7387_2271">
          <rect width="100%" height="100%" />
        </clipPath>
      </defs>
      <g clip-path="url(#clip0_7387_2271)">
        <path d="M2.5 13.9933C3.38406 13.9933 4.2319 14.3445 4.85702 14.9696C5.48214 15.5948 5.83333 16.4426 5.83333 17.3267C5.83333 16.4426 6.18452 15.5948 6.80964 14.9696C7.43477 14.3445 8.28261 13.9933 9.16667 13.9933C8.28261 13.9933 7.43477 13.6421 6.80964 13.017C6.18452 12.3919 5.83333 11.5441 5.83333 10.66C5.83333 11.5441 5.48214 12.3919 4.85702 13.017C4.2319 13.6421 3.38406 13.9933 2.5 13.9933Z" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.8334 11.4933C11.7174 11.4933 12.5653 11.8445 13.1904 12.4696C13.8155 13.0948 14.1667 13.9426 14.1667 14.8267C14.1667 13.9426 14.5179 13.0948 15.143 12.4696C15.7681 11.8445 16.616 11.4933 17.5 11.4933C16.616 11.4933 15.7681 11.1421 15.143 10.517C14.5179 9.89191 14.1667 9.04406 14.1667 8.16C14.1667 9.04406 13.8155 9.89191 13.1904 10.517C12.5653 11.1421 11.7174 11.4933 10.8334 11.4933Z" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.83337 5.65999C6.71743 5.65999 7.56528 6.01118 8.1904 6.6363C8.81552 7.26143 9.16671 8.10927 9.16671 8.99333C9.16671 8.10927 9.5179 7.26143 10.143 6.6363C10.7681 6.01118 11.616 5.65999 12.5 5.65999C11.616 5.65999 10.7681 5.3088 10.143 4.68368C9.5179 4.05856 9.16671 3.21072 9.16671 2.32666C9.16671 3.21072 8.81552 4.05856 8.1904 4.68368C7.56528 5.3088 6.71743 5.65999 5.83337 5.65999Z" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    `
  }
};


export default Icon;
